import { FormTextField as ExprWorksFormTextField } from '@diagentech/exprworks-ui-components';

import { withDisplayRule } from '@/features/displayRules/withDisplayRule';

export const FormTextField = withDisplayRule(ExprWorksFormTextField);
